import React from 'react';
import { EyeIcon, GraduationCapIcon, LayoutListIcon, PrinterIcon, WrenchIcon } from 'lucide-react';
import { differentiators } from '../data/content';
const ICONS = [WrenchIcon, EyeIcon, LayoutListIcon, PrinterIcon, GraduationCapIcon];
export function NotAnEbook() {
  return <section className="w-full bg-slate-950 px-5 py-12 text-white sm:py-14" data-id="element-124" data-mp="3qhkn0o1erobh">
      <div className="mx-auto max-w-[940px] text-center" data-id="element-125" data-mp="3qfgflw4aw76g">
        <h2 className="text-balance text-[1.5rem] font-extrabold uppercase leading-[0.95] tracking-tight sm:text-[1.9rem]" data-id="element-126" data-mp="3mgh41so2dc61">
          This Is NOT Another Financial Literacy Ebook
        </h2>
        <p className="mt-2 text-[1.25rem] font-extrabold uppercase leading-[0.95] tracking-tight text-orange-500 sm:text-[1.6rem]" data-id="element-127" data-mp="3cib3pfhwoe3a">
          It’s a Complete Ready-to-Teach System
        </p>

        <dl className="mx-auto mt-7 grid max-w-[640px] gap-x-6 gap-y-3 text-left sm:grid-cols-2" data-id="element-128" data-mp="1ap3rwg1i4em5">
          {differentiators.map((item, index) => {
          const Icon = ICONS[index % ICONS.length];
          return <div key={item.title} className="flex items-start gap-3" data-id="element-129" data-mp="3n25p1fww198z" data-mpi={index}>
                <Icon className="mt-0.5 h-4 w-4 shrink-0 text-orange-500" aria-hidden="true" data-id="element-130" data-mp="3s3l9b5r8rbqb" />
                <div data-id="element-131" data-mp="3d7nlqbvdvfpp">
                  <dt className="text-[0.95rem] font-extrabold uppercase leading-tight tracking-tight text-white" data-id="element-132" data-mp="3i44an8aepy3u">
                    {item.title}
                  </dt>
                  <dd className="mt-0.5 text-[0.9rem] leading-snug text-white/80" data-id="element-133" data-mp="9qwxegvxofz7">
                    {item.description}
                  </dd>
                </div>
              </div>;
        })}
        </dl>

        <p className="mt-7 text-balance text-[1rem] font-extrabold uppercase leading-tight tracking-tight text-white sm:text-[1.15rem]" data-id="element-134" data-mp="4xkln7ccs3nv">
          Less searching. More lessons already solved.
        </p>
      </div>
    </section>;
}